module.exports = __webpack_public_path__ + "static/media/gifRect.032c785a.gif";